module.exports = function(){ /* empty */ };


//////////////////
// WEBPACK FOOTER
// ./~/redux-api-middleware/~/core-js/library/modules/$.add-to-unscopables.js
// module id = 916
// module chunks = 0